module.exports = __webpack_public_path__ + "img/6_47925e801.png";